<template>
  <div>
    <div class="flex items-center">
      <slot />:
      <span
        class="ml-2 flex cursor-pointer items-center hover:text-brand-500"
        @click="show = !show"
      >
        <span class="whitespace-nowrap font-semibold">
          <slot name="dropdown" />
        </span>
        <span class="far ml-1" :class="{ 'fa-angle-down': !show, 'fa-angle-up': show }" />
      </span>
    </div>
    <div
      class="absolute left-0 right-0 z-50 mx-4 mt-3 flex flex-col overflow-hidden whitespace-nowrap rounded bg-white pt-3 shadow sm:mx-0"
      :class="{
        'sm:right-auto': !alignRight,
        'sm:left-auto': alignRight,
      }"
      v-if="show"
    >
      <div class="px-5 py-1 sm:pr-8">
        <label class="block" v-for="(id, value) in options" :key="id">
          <input
            type="checkbox"
            class="mr-1"
            :checked="isSelected(id)"
            @input="!isSelected(id) ? select(id) : deselect(id)"
          />
          {{ value }}
        </label>
        <div class="mt-2 text-sm text-gray-500">
          {{ $t('global.select') }}:
          <span
            class="cursor-pointer select-all hover:text-black"
            v-text="this.$t('global.all')"
            @click="selectAll"
          />
          /
          <span
            class="cursor-pointer select-none hover:text-black"
            v-text="this.$t('global.none')"
            @click="selectNone"
          />
        </div>
      </div>
      <div class="mt-3 flex justify-end bg-gray-100 p-2 text-sm">
        <button
          class="flex items-baseline rounded bg-brand-500 px-3 py-1 text-white hover:bg-brand-800 hover:text-brand-100"
        >
          <span class="far fa-check mr-1" />
          {{ $t('global.apply') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    isSelected(id) {
      return this.modelValue.includes(id)
    },
    select(id) {
      let selected = this.modelValue

      if (!selected.includes(id)) {
        selected.push(id)
      }

      this.$emit('update:modelValue', selected)
    },
    deselect(id) {
      let selected = this.modelValue

      if (selected.includes(id)) {
        selected = selected.filter((item) => {
          return item !== id
        })
      }

      this.$emit('update:modelValue', selected)
    },
    selectAll() {
      this.$emit('update:modelValue', Object.values(this.options))
    },
    selectNone() {
      this.$emit('update:modelValue', [])
    },
    closeIfClickedOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.show = false
      }
    },
  },
  watch: {
    show(show) {
      if (show) {
        document.addEventListener('click', this.closeIfClickedOutside)
      } else {
        document.removeEventListener('click', this.closeIfClickedOutside)
      }
    },
  },
  emits: ['update:modelValue'],
}
</script>
